import { fetchAggregateUsersData } from "./implementations/dataPlatformAggregateApi";

export async function fetchUsersData(accessToken, filter) {
    return await fetchAggregateUsersData(accessToken, filter);
}